module.exports = __webpack_public_path__ + "static/media/iconehospitalisation.0535dde2.png";